import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import eventApi from 'api/eventApi';
import { categoryList, mockMoreSportsCategory, mockSportCategory } from 'api/mockSportCategory';
import teaserApi from 'api/teaserApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { CancelTokenSource } from 'axios';
import AuthPage from 'features/auth/pages/AuthPage';
import ChangePasswordPage from 'features/auth/pages/ChangePasswordPage';
import ButtonChatRoom from 'features/chatRoom/ButtonChatRoom';
import ChatContainerMobile from 'features/chatRoom/components/ChatContainerMobile';
import useCheckKYCForPoker from 'hooks/useCheckKYCForPoker';
import useUserDetail from 'hooks/useUserDetail';
import React, { useEffect, useMemo, useState } from 'react';
import ReactConfetti from 'react-confetti';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { selectShowChatMobile } from 'redux/chatSlice';
import { seleteUpdateGameResult } from 'redux/gameSlice';
import { platformStates } from 'redux/platformSlice';
import { setLevelPoints, setTeamPoints, setTeaserPoints } from 'redux/teaserSlice';
import { selectLoading } from 'redux/userSlice';
import { isLaptop, isPhone, isTablet } from 'utils/commonUtils';
import FooterMenu from '../../../components/Commons/FooterMenu';
import Header from '../../../components/Commons/Header';
import BetFormButton from '../components/BetForm/BetFormButton';
import HomeMainWrapper from '../components/HomeMainWrapper';
import MfaModal from '../components/Modals/MfaModal';
import TransactionModal from '../components/Modals/TransactionModal';
import SearchItem from '../components/SearchItem';
import {
  onChangeAuthPage,
  selectBets,
  selectGames,
  selectIsShowBetForm,
  selectSearch,
  selectShowConfetti,
  setEvent,
  setSearch,
  setShowConfetti,
  setShowSubMenu,
} from '../homeSlice';
interface HomePageProps {}

const HomePage: React.FunctionComponent<HomePageProps> = (props) => {
  const { innerWidth: width, innerHeight: height } = window;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const search = useAppSelector(selectSearch);
  const games = useAppSelector(selectGames);
  const bets = useAppSelector(selectBets);
  const updateGameResult = useAppSelector(seleteUpdateGameResult);
  const isShowBetForm = useAppSelector(selectIsShowBetForm);
  const [searchParams, setSearchParams] = useSearchParams();
  const { isUserLoggedIn, currentUser } = useUserDetail();
  const { checkKYC } = useCheckKYCForPoker();
  const [cancelTokenSource, setCancelTokenSource] = useState<CancelTokenSource | null>(null);
  const [isShowChangePasswordForm, setIsShowChangePasswordForm] = useState<boolean>(false);
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const selectedShowChatMobile = useAppSelector(selectShowChatMobile);
  const platform = useAppSelector(platformStates);
  const [isFetchError, setIsFetchError] = useState<boolean>(false);
  const showConfetti = useAppSelector(selectShowConfetti);
  const isLoading = useAppSelector(selectLoading);
  const closeForm = (): void => {
    dispatch(onChangeAuthPage(-1));
    dispatch(setShowSubMenu(false));
    setIsShowChangePasswordForm(false);
  };

  const onShowChangePasswordPage = () => {
    if (isUserLoggedIn) setIsShowChangePasswordForm(true);
  };

  const getTeaser = async () => {
    const teamPoints = await teaserApi.getTeamPoints();
    if (teamPoints.ok && teamPoints.body) {
      dispatch(setTeamPoints(teamPoints.body));
    }
    const levelPoints = await teaserApi.getLevelPoints();
    if (levelPoints.ok && levelPoints.body) {
      dispatch(setLevelPoints(levelPoints.body));
    }
    const teaserPoints = await teaserApi.getTeaserPoint();
    if (teaserPoints.ok && teaserPoints.body) {
      dispatch(setTeaserPoints(teaserPoints.body));
    }
  };

  // const fetchData = async () => {
  //   const source = axios.CancelToken.source();
  //   setCancelTokenSource(source);

  //   dispatch(setOldGames(games));
  //   if (!searchParams.get('category') || !tab) {
  //     // setSearchParams({ category: 'Football', tab: 'NCAAF' });
  //     setSearchParams({ category: 'Soccer', tab: 'EPL' });

  //     return;
  //   }

  //   dispatch(setLoading());

  //   const gameIds = bets.length
  //     ? bets
  //         .map((bet) => bet.gameId)
  //         .filter((value, index, self) => self.indexOf(value) === index)
  //         .join(',')
  //     : null;

  //   const params =
  //     tab !== 'Futures'
  //       ? {
  //           'sportTitle.in': search.isSearchLayout ? '' : tab || 'NCAAF',
  //           'status.in': 'UPCOMING,LIVE',
  //           'id.in': gameIds,
  //           sort: 'startDate,asc',
  //           size: 999,
  //           'main.equals': true,
  //           'isHidden.equals': false,
  //           ...(search.isSearchLayout && {
  //             'homeTeam.contains': search.searchText,
  //             'awayTeam.contains': search.searchText,
  //           }),
  //         }
  //       : {
  //           'status.in': 'UPCOMING,LIVE',
  //           'id.in': gameIds,
  //           sort: 'startDate,asc',
  //           size: 999,
  //           'main.equals': true,
  //           'isHidden.equals': false,
  //           'homeTeam.in': '',
  //           'awayTeam.in': '',
  //         };

  //   const { ok, body } = await oddsApi.getGames(params, source.token);

  //   if (ok && body) {
  //     dispatch(setGames(body));
  //     dispatch(resetLoading());
  //   } else {
  //     setIsFetchError(true);
  //   }
  // };

  const handleAfterCheck = () => {
    if (window.innerWidth > 1024) {
      navigate('/casino/game/poker/play');
    }
  };

  const tab = useMemo((): string | null => {
    return searchParams.get('tab');
  }, [searchParams]);

  useEffect(() => {
    getTeaser();
    if (searchParams.get('sign-up') === 'true') {
      searchParams.delete('sign-up');
      setSearchParams(searchParams);
      dispatch(onChangeAuthPage(1));
    }

    if (searchParams.get('login') === 'true') {
      searchParams.delete('login');
      setSearchParams(searchParams);
      dispatch(onChangeAuthPage(0));
    }

    if (searchParams.get('poker') === 'true' && window.innerWidth > 1024) {
      searchParams.delete('poker');
      setSearchParams(searchParams);
      checkKYC(handleAfterCheck);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   dispatch(setGames(undefined));
  //   if (cancelTokenSource) {
  //     cancelTokenSource.cancel('Request canceled due to new tab');
  //   }
  //   fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [tab, search]);

  // useEffect(() => {
  //   if (updateGameResult !== '' || currentUser?.id) {
  //     fetchData();
  //   }
  // }, [updateGameResult, currentUser?.id]);

  // useEffect(() => {
  //   if (isFetchError) {
  //     fetchData();
  //     setIsFetchError(false);
  //   }
  // }, [isFetchError]);

  // useEffect(() => {
  // if (!isLoading) {
  //   const idInterval = setInterval(() => {
  //     fetchData();
  //   }, 3000);
  //   return () => {
  //     clearInterval(idInterval);
  //   };
  // }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [tab, games, bets, search, isLoading]);

  const getEvent = async () => {
    const { ok, body } = await eventApi.getEvent();
    if (ok && body) {
      dispatch(setEvent(body));
    }
  };

  useEffect(() => {
    getEvent();
  }, []);

  useEffect(() => {
    const category = searchParams.get('category');
    const isCategoryValid = categoryList.find((c) => c.category === category);
    const isTabValid =
      mockSportCategory.find((c) => c.sportTitle === tab) ||
      mockMoreSportsCategory.find((c) => c.sportTitle === tab);

    if (!category || !isCategoryValid) {
      setSearchParams({ category: 'soccer', tab: 'EPL' });

      return;
    }

    if (!tab || !isTabValid) {
      const firstCategoryMatch = mockSportCategory.find(
        (c) => c.sportActivity.toLowerCase() === category,
      );

      setSearchParams({
        category,
        tab: firstCategoryMatch?.sportTitle || '',
      });
    }
  }, [searchParams]);

  const onPressEnter = (value: string) => {
    dispatch(
      setSearch({
        searchText: value,
        isSearchLayout: !!value,
      }),
    );
  };

  const handleSearch = () => {
    if (search.searchText) {
      dispatch(setSearch({ searchText: '', isSearchLayout: false }));
    }
    setShowSearch((prev) => !prev);
  };

  const stopConfetti = () => {
    dispatch(setShowConfetti(false));
  };

  return (
    <div className="main-page relative">
      <i className="version">Version 1.0</i>
      <div
        className={`body-waraper  ${
          isShowBetForm && !selectedShowChatMobile ? 'prevent-scroll' : ''
        }`}
      >
        <Header isHomeScreen onShowChangePasswordPage={onShowChangePasswordPage} />
        <HomeMainWrapper />
        <FooterMenu
          isUserLogin={isUserLoggedIn}
          onShowChangePasswordPage={onShowChangePasswordPage}
        />
        {!selectedShowChatMobile &&
          (isPhone(platform) || isTablet(platform) || isLaptop(platform)) && <ButtonChatRoom />}
        {!(isPhone(platform) || isTablet(platform) || isLaptop(platform)) && <BetFormButton />}
        <div className="search-bar-footer ">
          <div className="search-bar">
            <button
              className={`authen-button ${
                isPhone(platform) || isTablet(platform) || isLaptop(platform)
                  ? 'authen-button-mobile'
                  : ''
              } `}
              onClick={handleSearch}
            >
              {showSearch ? (
                <CloseOutlined className="search-icon" />
              ) : (
                <SearchOutlined className="search-icon" />
              )}
            </button>
            {showSearch && <SearchItem onSubmit={onPressEnter} />}
          </div>
        </div>
      </div>
      {selectedShowChatMobile && <ChatContainerMobile />}
      <ChangePasswordPage isShow={isShowChangePasswordForm} closePage={closeForm} />
      <AuthPage />
      <TransactionModal />
      <MfaModal />
      {showConfetti && (
        <ReactConfetti
          gravity={0.7}
          className="confetti"
          numberOfPieces={200}
          style={{ zIndex: 1050 }}
          recycle={false}
          onConfettiComplete={stopConfetti}
        />
      )}
    </div>
  );
};

export default HomePage;
